import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import posthog from 'posthog-js';
import smartlookClient from 'smartlook-client';
import { smartlook } from '../../config';
import { RootState } from "src/redux/store";

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;
interface User {
  id: string | number;
  email: string;
}

interface ProductAnalyticWrapperProps {
  children: JSX.Element;
}

function ProductAnalyticWrapper({ children }: ProductAnalyticWrapperProps): JSX.Element {

  const subscriptionType = useSelector((state: RootState) =>
    _.get(state, 'accounts.item.subscription.type', null)
  );

  const user = useSelector((state: RootState): User | null => {
    const id = _.get(state, 'users.me.id');
    const email = _.get(state, 'users.me.email');
    return id && email ? { id, email } : null;
  });

  // PostHog — init for all users
  useEffect(() => {
    if (!user?.id || !user?.email) return;

    if (!posthog.__loaded) {
      posthog.init(POSTHOG_KEY as string, {
        api_host: POSTHOG_HOST,
        autocapture: true,
        capture_pageview: true,
      });
    }

    if (posthog.get_distinct_id() !== String(user.id)) {
      posthog.reset();
    }

    posthog.identify(String(user.id), {
      email: user.email,
      subscription_type: subscriptionType,
    });
  }, [user, subscriptionType]);

  // Smartlook — PAID users only
  useEffect(() => {
    if (subscriptionType !== 'PAID') return;

    if (smartlook && smartlook.projectKey) {
      smartlookClient.init(smartlook.projectKey);
    }
  }, [subscriptionType]);

  return children;
}

export default ProductAnalyticWrapper;